<template>
        <div class="">
            <div class="pos-r flex-container vfull couponsList bg-white" style="min-height: 95px" 
                    :class="!coupon.couponToActivity.remainQty?'couponsList3':(coupon.useWay===2?'couponsList1':'couponsList2')">
                <div class="flex-container-col center text-white couponHeadContainer" style="min-width: 100px;max-width: 100px;overflow:hidden">

                    <!-- 金额显示 -->
                    <div class="lh-1" v-if="formatData.detailType == 'cash'">
                        <span class="fs-20">&yen;</span><span style="font-size:33px"v-text="formatData.detailDes1"></span><span class="fs-20" v-text="formatData.detailDes2"></span>
                    </div>
                    <div class="lh-1" v-if="formatData.detailType == 'discount'">
                        <span style="font-size:33px" v-text="formatData.detailDes1"></span><span class="fs-20" v-text="formatData.detailDes2"></span>
                    </div>
                    <div class="lh-1" v-if="formatData.detailType == 'text'">
                        <span style="font-size:25px;" v-text="formatData.detailDes1"></span>
                    </div>

                    <!-- 限制条件 -->
                        <div v-text="formatData.detailTips" :class="formatData.detailMoreTips?'fs-10':'fs-11'"></div>
                        <div class="fs-10" v-text="formatData.detailMoreTips" v-if="formatData.detailMoreTips"></div>

                </div>
                <div class="flex1 paddingt20 paddingh20" style="border-left:0;">
                    <div class="flex-container top">
                        <div class="flex1 lh-1 text-limit2" style="height: 28px;">
                            <span class="badge badge-radius badge-small fs-10 couponsBadge" style="padding: 2px 3px;" 
                                    v-text="formatData.typeName"></span>
                            <span class="fs-13 margint10 text-darker" v-text="coupon.name"></span>
                        </div>
                    </div>
                    <div class="flex-container bottom marginv10">
                        <div class="flex1"><span class="fs-11 text-light lh-1" v-text="coupon | dateFormat"></span></div>
                        <div class="badge badge-pill couponsBadge" style="min-width: 60px" @click="exchange(coupon)" 
                                data-scp="couponItemExchange.{{$index}}">
                            <span class="dis-i text-center fs-10" style="line-height: 14px">
                                <span v-text="coupon.couponToActivity.remainQty?'立即领取':'已抢光'"></span>
                            </span>
                        </div>
                    </div>
                    <div class="flex-container top pos-r" @click="formatData.showMore = !formatData.showMore" 
                            data-scp="couponItemShowMore.{{$index}}">
                        <div class="flex1">
                            <div class="text-light fs-10 text-limit1" v-text="formatData.couponToStoreSetValue" style="overflow:hidden;"></div>
                        </div>
                        <div class="text-right text-light lh-1" style="min-width: 20px;">
                            <i class="icon fs-16" :class="formatData.showMore?'icon-fold':'icon-unfold'"></i>
                        </div>
                    </div>
                </div>
            </div>
            <!-- 券详情 -->
            <div class="bg-white padding20" v-show="formatData.showMore">
                <div class="flex-container top">
                    <div class="text-light paddingr10">适用范围：</div>
                    <div class="text-dark flex1" v-text="formatData.couponToStoreSetValue"></div>
                </div>
                <div class="flex-container top">
                    <div class="text-light paddingr10">使用期限：</div>
                    <div class="text-dark flex1" v-text="coupon | dateFormat"></div>
                </div>
                <div class="flex-container top">
                    <div class="text-light paddingr10">使用详情：</div>
                    <div class="text-dark flex1" v-html="coupon.couponDetail.detailContent"></div>
                </div>
            </div>
        </div>
</template>
<style lang="scss">
    .couponsList{
        overflow: hidden;
    }
    .couponsList:before,
    .couponsList:after {
        content: '';
        height: 12px;
        width: 12px;
        background-color: #eeeeee;
        border-radius: 100%;
        -webkit-border-radius: 100%;
        -moz-border-radius: 100%;
        -o-border-radius: 100%;
        display: block;
        position: absolute;
        left: 94px;
    }
    .couponsList:before {
        top: -5px;
    }
    .couponsList:after {
        bottom: -5px;
    }
    .couponsList1:before,
    .couponsList1:after{
        border: 1px solid #ff898c;
    }
    .couponsList1>div{
        border: 1px solid #ff898c;
    }
    .couponsList1 .couponHeadContainer{
        background: #FF898C;
    }
    .couponsList1 .couponsBadge{
        background: #FF898C;
    }
    .couponsList2:before,
    .couponsList2:after{
        border: 1px solid #ffbc59;
    }
    .couponsList2>div{
        border: 1px solid #ffbc59;
    }
    .couponsList2 .couponHeadContainer{
        /*background: #ffbc59;*/
    }
    .couponsList2 .couponsBadge{
        background: #ffbc59;
    }
    .couponsList3:before,
    .couponsList3:after{
        border: 1px solid #CCCCCC;
    }
    .couponsList3>div{
        border: 1px solid #CCCCCC;
    }
    .couponsList3 .couponHeadContainer{
        background: #CCCCCC;
    }
    .couponsList3 .couponsBadge{
        background: #CCCCCC;
    }
</style>
<script>
import couponServer from '../../api/couponServer.js';
Vue.filter('dateFormat', function(coupon){

    let promotionRule=JSON.parse(coupon.promotionRule||'{}')
    let fixedLength=_.get(promotionRule,'fixedLength');
    if(fixedLength){
        return `自领取之日起${fixedLength}天内有效`
    }
    let start = new Date(_.get(coupon,'startTime'))
        , end = new Date(_.get(coupon,'endTime'));

    return `${maple.util.formatDateByStr(start, 'YYYY.MM.DD')}-${maple.util.formatDateByStr(end, 'YYYY.MM.DD')}`;
});
function convertOneCoupon(content) {
    const //券类型
        COUPON_TYPE = {
            CASH: 1,         //现金券
            DISCOUNT: 2,     //折扣券
            REDUCE: 3,       //满减券
            GIFT: 4,         //买送券
            PARK: 8,         //停车券
            NEW_CASH: 10,    //抵值券
            NEW_DISCOUNT: 11 //新折扣券
        };

    let detailType, colorType, promotionRule = content.promotionRule && JSON.parse(content.promotionRule) || {},
        detailDes, detailDes1, detailDes2, detailSubName, detailTips, detailMoreTips;                 //取值范围 cash 金额显示；discount 折扣显示；text 文字显示
    //detailName 
    //detailType 逻辑


    if (content.type === COUPON_TYPE.CASH || content.type === COUPON_TYPE.PARK) {
        //现金券 和 停车券
        detailType = 'cash';
        detailDes = promotionRule.cash;
        detailDes1 = Math.floor(detailDes);
        detailDes2 = (detailDes+'').match(/\.\d/)?(detailDes+'').match(/\.\d/)[0]:'';
        detailTips = '无金额门槛';
    } else if (content.type === COUPON_TYPE.REDUCE) {
        //满减券
        detailType = 'cash';
        detailDes = promotionRule.minus;
        detailDes1 = Math.floor(detailDes);
        detailDes2 = (detailDes+'').match(/\.\d/)?(detailDes+'').match(/\.\d/)[0]:'';
        if (promotionRule.full) {
            detailTips = `${promotionRule.every ? '每' : ''}满${promotionRule.full}元可用`;      //TOOD 每满的逻辑需要优化啊
        } else {
            detailTips = '无金额门槛';
        }
        if (promotionRule.maximumDiscount) {
            detailMoreTips = `最高优惠${promotionRule.maximumDiscount}元`;
        }
    } else if (content.type === COUPON_TYPE.DISCOUNT || content.type === COUPON_TYPE.NEW_DISCOUNT) {
        //折扣券
        detailType = 'discount';
        detailDes = promotionRule.discount;
        detailDes1 = Math.floor(detailDes);
        detailDes2 = ((detailDes+'').match(/\.\d/)?(detailDes+'').match(/\.\d/)[0]:'')+'折';
        detailTips = '无金额门槛';
        if (promotionRule.maximumDiscount) {
            detailMoreTips = `最高优惠${promotionRule.maximumDiscount}元`;
        }
    }else if(content.type === COUPON_TYPE.NEW_CASH){
        //现金券 和 停车券
        detailType = 'cash';
        detailDes = promotionRule.minus;
        detailDes1 = Math.floor(detailDes); 
        detailDes2 = (detailDes+'').match(/\.\d/)?(detailDes+'').match(/\.\d/)[0]:'';
        if (promotionRule.full) {
            detailTips = `满${promotionRule.full}元可用`;
        } else {
            detailTips = '无金额门槛';
        }
    } else {
        //赠品券
        detailType = 'text';
        detailDes1 = '赠品';
    }

    //subName 逻辑
    if (content.type === COUPON_TYPE.CASH || content.type === COUPON_TYPE.NEW_CASH) {
        detailSubName = '现金';
    } else if (content.type === COUPON_TYPE.PARK) {
        detailSubName = '停车';
    } else if (content.type === COUPON_TYPE.DISCOUNT || content.type === COUPON_TYPE.NEW_DISCOUNT) {
        detailSubName = '折扣';
    } else if (content.type === COUPON_TYPE.GIFT) {
        detailSubName = '赠品';
    } else if (content.type === COUPON_TYPE.REDUCE) {
        detailSubName = '满减';
    }

    return {
        id: content.id,
        detailName: content.name,
        colorType,
        detailType:detailType||'',
        detailDes:detailDes||'',
        detailDes1:detailDes1||'',
        detailDes2:detailDes2||'',
        detailTips:detailTips||'',
        detailMoreTips:detailMoreTips||'',
        publishTime: content.publishTime,
        offTime: content.offTime,
        detailSubName
    };
}
export default {
	props:{
		coupon:Object,
        color:''
	},
    data:function(){
        return {
            formatData:{
                showMore:false,
                couponToStoreSetValue:'',
                typeName:'',
                detailType:'',
                detailDes:'',
                detailDes1:'',
                detailDes2:'',
                detailTips:'',
                detailMoreTips:'',
            }
        }
    },
	methods:{
		exchange(item){
            couponServer.couponCodeAdd({
                data: {
                    couponId: item.id
                },
                success() {
                    maple.notice('领取成功')
                }
            })
		}
	},
    ready(){
        const TAG_NAME_LIST = {
            '1':'现金',
            '2':'折扣',
            '3':'满减',
            '4':'买送',
            '10':'抵值',
            '11':'打折'
        };
        let coupon=this.coupon;
        this.formatData.couponToStoreSetValue = coupon.couponToStoreSet.map( store => store.name).join(',');
        this.formatData.typeName = TAG_NAME_LIST[coupon.type];
        let {detailType, detailDes , detailDes1 , detailDes2 , detailTips , detailMoreTips} = convertOneCoupon(coupon);
        this.formatData.detailType = detailType;
        this.formatData.detailDes = detailDes;
        this.formatData.detailDes1 = detailDes1;
        this.formatData.detailDes2 = detailDes2;
        this.formatData.detailTips = detailTips;
        this.formatData.detailMoreTips = detailMoreTips;
        if(this.color){
            maple.style('.couponsList2 .couponsBadge',{'background': this.color})
            maple.style('.couponsList2 .couponHeadContainer',{
                color:this.color,
                'border-right':'1px solid '+this.color
            })
            maple.style('.couponsList2:before',{'border':'1px solid '+this.color})
            maple.style('.couponsList2:after',{'border':'1px solid '+this.color})
            maple.style('.couponsList2>div',{'border':'1px solid '+this.color})
            maple.style('.couponsList:before, .couponsList:after',{'background': this.color})
        }
    }
}
</script>